<template>
  <v-flex class="pa-2" xs12>
    <section class="sale-log-panel" :class="{ dark: isDark }">
      <div class="sale-log-header">
        <v-avatar class="sale-log-icon" size="38">
          <v-icon>mdi-timeline-text-outline</v-icon>
        </v-avatar>
        <div>
          <strong>Atividade da venda</strong>
          <small>Comentarios e movimentacoes importantes</small>
        </div>
        <v-spacer />
        <v-btn small text :color="isDark ? '#9be7bd' : '#1f8f55'" @click="showMovimentation">
          {{ show_movimentation ? "Ocultar movimentos" : "Mostrar movimentos" }}
        </v-btn>
      </div>

      <div class="sale-comment-box">
        <v-text-field
          append-icon="mdi-send"
          :color="$theme.primary"
          dense
          :disabled="loading"
          outlined
          rounded
          hide-details
          v-model="comment"
          @keyup.enter.prevent="sendComment"
          @click:append="sendComment"
          placeholder="Escreva um comentario..."
        />
      </div>

      <div class="sale-log-list">
        <article
          v-for="(historic, index) in get_gestordepedido.historico_de_status"
          v-show="show_movimentation"
          :key="`historic-${historic.status || historic.description}-${index}`"
          class="sale-log-row movement"
        >
          <span class="sale-log-dot"><v-icon size="15">mdi-cog-outline</v-icon></span>
          <div>
            <strong>{{ historic.status || historic.description }}</strong>
            <small>{{ historicExecutor(historic) }} em {{ $moment(historic.created_at || historic.date).format("lll") }}</small>
          </div>
        </article>

        <article
          v-for="(item, index) in get_gestordepedido.comments"
          :key="`comment-${item.description}-${index}`"
          class="sale-log-row comment"
        >
          <v-avatar size="34" class="sale-log-avatar">
            <v-img v-if="item.executor && item.executor.photo" :src="item.executor.photo[0]" />
            <v-icon v-else color="#1f8f55">mdi-account-circle</v-icon>
          </v-avatar>
          <div>
            <strong>{{ item.description }}</strong>
            <small>{{ firstName(item.executor) }} em {{ $moment(item.created_at).format("lll") }}</small>
          </div>
        </article>

        <div v-if="!show_movimentation && (!get_gestordepedido.comments || !get_gestordepedido.comments.length)" class="sale-log-empty">
          <v-icon color="#8ea39a">mdi-comment-outline</v-icon>
          <span>Nenhum comentario ainda.</span>
        </div>
      </div>
    </section>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      comment: "",
      loading: false,
      show_movimentation: false
    };
  },
  computed: {
    ...mapGetters(["get_gestordepedido"]),
    isDark() {
      return localStorage.dark === "true";
    }
  },
  methods: {
    ...mapActions([
      "createGlobalMessage",
      "listar_gestordepedidos"
    ]),
    showMovimentation() {
      this.show_movimentation = !this.show_movimentation;
    },
    firstName(user = {}) {
      return user.nome ? user.nome.split(" ")[0] : "";
    },
    historicExecutor(historic = {}) {
      if (historic.executor && historic.executor.nome) return this.firstName(historic.executor);
      if (typeof historic.executor === "string") return historic.executor;
      return "...";
    },
    sendComment() {
      if (!this.comment.trim()) return;
      this.loading = true;
      this.$run("transacoes/make-comment", {
        _id: this.get_gestordepedido._id,
        comment: this.comment
      })
        .then(res => {
          this.loading = false;
          this.comment = "";
          this.listar_gestordepedidos(true);
          const sale = res.data;
          sale.comments = sale.comments ? sale.comments.reverse() : [];
          this.$store.commit("set_gestordepedido", sale);
        })
        .catch(e => {
          this.loading = false;
          this.createGlobalMessage({
            type: "error",
            text: e.message
          });
        });
    }
  }
};
</script>

<style scoped>
.sale-log-panel { margin: 10px 8px 18px; padding: 16px; border-radius: 20px; background: #f8fbf9; border: 1px solid #dfe9e4; box-shadow: 0 14px 34px rgba(15, 35, 28, .08); }
.sale-log-header { display: flex; align-items: center; gap: 12px; margin-bottom: 14px; }
.sale-log-header strong,.sale-log-header small,.sale-log-row strong,.sale-log-row small { display: block; }
.sale-log-header strong { color: #14251d; font-size: 16px; }
.sale-log-header small,.sale-log-row small,.sale-log-empty { color: #6f8178; }
.sale-log-icon { background: #e8f7ef !important; color: #1f8f55 !important; }
.sale-comment-box { margin-bottom: 12px; }
.sale-log-list { display: flex; flex-direction: column; gap: 9px; }
.sale-log-row { display: flex; align-items: flex-start; gap: 10px; padding: 12px; border-radius: 16px; background: #fff; border: 1px solid #e4ece8; }
.sale-log-row.movement { background: #fff8ed; border-color: #f0ddbd; }
.sale-log-dot { display: flex; align-items: center; justify-content: center; width: 34px; height: 34px; border-radius: 999px; background: #e8f7ef; color: #1f8f55; flex: 0 0 auto; }
.sale-log-avatar { background: #e8f7ef; flex: 0 0 auto; }
.sale-log-empty { display: flex; align-items: center; justify-content: center; gap: 8px; padding: 22px; border: 1px dashed #cbd8d1; border-radius: 16px; }
.sale-log-panel.dark { background: #111b21; border-color: #26343c; box-shadow: none; }
.sale-log-panel.dark .sale-log-header strong,.sale-log-panel.dark .sale-log-row strong { color: #eef4f1; }
.sale-log-panel.dark .sale-log-header small,.sale-log-panel.dark .sale-log-row small,.sale-log-panel.dark .sale-log-empty { color: #8ea39a; }
.sale-log-panel.dark .sale-log-row { background: #182229; border-color: #26343c; }
.sale-log-panel.dark .sale-log-row.movement { background: #1c252b; border-color: #34424a; }
.sale-log-panel.dark .sale-log-icon,.sale-log-panel.dark .sale-log-dot,.sale-log-panel.dark .sale-log-avatar { background: #0b3b2a !important; color: #9be7bd !important; }
</style>
